import { ButtonHTMLAttributes } from "react";

import { cv } from "../tokens";

type ButtonVariant = "primary" | "secondary" | "card";

interface CardVaultButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const baseStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.5rem",
  fontSize: "0.8rem",
  border: "none",
  borderRadius: 6,
  padding: "10px 24px",
  cursor: "pointer",
  transition: "all 0.4s ease",
  fontFamily: "inherit",
};

const variantStyles: Record<ButtonVariant, React.CSSProperties> = {
  primary: {
    backgroundColor: cv.yellow,
    color: cv.black,
    border: "none",
  },
  secondary: {
    backgroundColor: "transparent",
    color: cv.grey,
    border: `1px solid ${cv.grey}`,
  },
  card: {
    backgroundColor: "transparent",
    color: cv.black,
    border: `1px solid ${cv.black}`,
    textTransform: "uppercase",
  },
};

export function CardVaultButton({
  children,
  variant = "primary",
  disabled = false,
  style,
  ...rest
}: CardVaultButtonProps) {
  return (
    <button
      data-cv-btn={variant}
      {...rest}
      disabled={disabled}
      style={{ ...baseStyle, ...variantStyles[variant], opacity: disabled ? 0.5 : 1, ...style }}
    >
      {children}
    </button>
  );
}
